import DashboardDIRWidget from './DashboardDIRWidget/DashboardDIRWidget';
import { useEffect, useMemo } from 'react';
import { calculateProgressionPercentage } from '../../../../../../utils/helpers/numbers/calculateProgressionPercentage';
import moment from 'moment';
import { DashboardDIRLayoutProps } from '../DashboardDIR.types';

export default ({ data: widgetInfos }: DashboardDIRLayoutProps) => {
  const wonTotal = useMemo(
    () => widgetInfos?.won.reduce((acc, { count }) => acc + count, 0),
    [widgetInfos]
  );

  const wonCurrentStat = useMemo(() => {
    const [month, year] = moment().format('M,Y').split(',');
    return (
      widgetInfos?.won.find(
        (item) => item.month === parseInt(month) && item.year === parseInt(year)
      )?.count || 0
    );
  }, [widgetInfos]);

  const wonStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // widgetInfos?.won.reduce((acc, { count }) => [...acc, count], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          return (
            widgetInfos?.won.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.count || 0
          );
        })
        .reverse(),
    [widgetInfos]
  );

  const wonProgression = useMemo(() => {
    const length = widgetInfos?.won.length || 0;
    // const currentMonth = length > 0 ? widgetInfos?.won[length - 1].count || 0 : 0
    // const lastMonth = length > 1 ? widgetInfos?.won[length - 2].count || 0 : 0
    if (length > 0) {
      const previousMonth =
        widgetInfos?.won.find(
          (item) =>
            item.month === parseInt(moment().subtract(1, 'month').format('M')) &&
            item.year === parseInt(moment().subtract(1, 'month').format('YYYY'))
        )?.count || 0;
      const currentMonth =
        widgetInfos?.won.find(
          (item) =>
            item.month === parseInt(moment().format('M')) &&
            item.year === parseInt(moment().format('YYYY'))
        )?.count || 0;
      return calculateProgressionPercentage(previousMonth, currentMonth);
    } else {
      return 0;
    }
  }, [widgetInfos]);

  const total = useMemo(
    () => widgetInfos?.total.reduce((acc, { count }) => acc + count, 0),
    [widgetInfos]
  );

  const totalCurrentStat = useMemo(() => {
    const [month, year] = moment().format('M,Y').split(',');
    return (
      widgetInfos?.total.find(
        (item) => item.month === parseInt(month) && item.year === parseInt(year)
      )?.count || 0
    );
  }, [widgetInfos]);

  const totalStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // widgetInfos?.total.reduce((acc, { count }) => [...acc, count], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          return (
            widgetInfos?.total.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.count || 0
          );
        })
        .reverse(),
    [widgetInfos]
  );

  const totalProgression = useMemo(() => {
    const totalLength = widgetInfos?.total.length || 0;
    // const currentMonth = totalLength > 0 ? widgetInfos?.total[totalLength - 1].count || 0 : 0
    // const lastMonth = totalLength > 1 ? widgetInfos?.total[totalLength - 2].count || 0 : 0
    if (totalLength > 0) {
      const previousMonth =
        widgetInfos?.total.find(
          (item) =>
            item.month === parseInt(moment().subtract(1, 'month').format('M')) &&
            item.year === parseInt(moment().subtract(1, 'month').format('YYYY'))
        )?.count || 0;
      const currentMonth =
        widgetInfos?.total.find(
          (item) =>
            item.month === parseInt(moment().format('M')) &&
            item.year === parseInt(moment().format('YYYY'))
        )?.count || 0;
      return calculateProgressionPercentage(previousMonth, currentMonth);
    } else {
      return 0;
    }
  }, [widgetInfos]);

  const ratioCurrentStat = useMemo(() => {
    const [month, year] = moment().format('M,Y').split(',');
    const ratio =
      widgetInfos?.win_ratio.find(
        (item) => item.month === parseInt(month) && item.year === parseInt(year)
      )?.ratio || 0;
    return ratio || 0;
  }, [widgetInfos]);

  const ratioStats = useMemo(
    () =>
      [...Array(6)]
        .map((_, index) => {
          // widgetInfos?.win_ratio.reduce((acc, { ratio }) => [...acc, ratio], [] as number[])
          const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
          const ratio =
            widgetInfos?.win_ratio.find(
              (item) => item.month === parseInt(month) && item.year === parseInt(year)
            )?.ratio || 0;
          return ratio > 0 ? ratio * 100 : 0;
        })
        .reverse(),
    [widgetInfos]
  );

  const ratioProgression = useMemo(() => {
    const length = widgetInfos?.win_ratio.length || 0;
    // const currentMonth = length > 0 ? widgetInfos?.win_ratio[length - 1].ratio || 0 : 0
    // const lastMonth = length > 1 ? widgetInfos?.win_ratio[length - 2].ratio || 0 : 0
    if (length > 0) {
      const previousMonth =
        widgetInfos?.win_ratio.find(
          (item) =>
            item.month === parseInt(moment().subtract(1, 'month').format('M')) &&
            item.year === parseInt(moment().subtract(1, 'month').format('YYYY'))
        )?.ratio || 0;
      const currentMonth =
        widgetInfos?.win_ratio.find(
          (item) =>
            item.month === parseInt(moment().format('M')) &&
            item.year === parseInt(moment().format('YYYY'))
        )?.ratio || 0;
      return calculateProgressionPercentage(previousMonth, currentMonth);
    } else {
      return 0;
    }
  }, [widgetInfos]);

  useEffect(() => console.log('totalProgression', totalProgression), [totalProgression]);
  useEffect(() => console.log('ratioProgression', ratioProgression), [ratioProgression]);

  return (
    <section className="dashboard__widget-list">
      <DashboardDIRWidget
        title="Prospects gagnés"
        subtitle={`${wonTotal} au total`}
        currentStat={wonCurrentStat.toString()}
        stats={wonStats}
        progression={wonProgression}
      />
      <DashboardDIRWidget
        title="Entreprises prospectées"
        subtitle={`${total} au total`}
        currentStat={totalCurrentStat.toString()}
        stats={totalStats}
        progression={totalProgression}
        isSecondary
      />
      <DashboardDIRWidget
        title="Taux de conversion"
        currentStat={`${ratioCurrentStat === 0 ? 0 : ratioCurrentStat * 100}%`}
        stats={ratioStats}
        progression={ratioProgression}
      />
    </section>
  );
};
